import { Route, NavigationGuardNext } from 'vue-router';
import { getSharedApolloClient } from '@/lib/apollo_setup';
import { FETCH_PARENT_REGISTRATION } from '@/graphql/account/queries';

const LEGACY_SEARCH_CARE_TYPES = ['PET_CARE', 'HOUSEKEEPING', 'COMPANION_CARE', 'SPECIAL_NEEDS'];

export function buildLegacyProviderSearchUrl(searchStrategy: string, zipcode?: string): string {
  const query: Record<string, string> = { search_strategy: searchStrategy };
  if (zipcode) query.zipcode = zipcode;
  return `/profile/provider/search?${new URLSearchParams(query).toString()}`;
}

const searchCareTypeGuard = async (to: Route, _from: Route, next: NavigationGuardNext) => {
  const careType = typeof to.query?.careType === 'string' ? to.query.careType.toLowerCase() : '';
  const hasNonDefaultCareType = Boolean(careType && careType !== 'both');

  // Respect explicit strategy/careType selection in the URL, but keep evaluating default careType=both
  // so legacy parent care types can still be redirected.
  if (to.query?.search_strategy || hasNonDefaultCareType) {
    next();
    return;
  }

  try {
    const apolloClient = getSharedApolloClient();
    const { data } = await apolloClient.query({
      query: FETCH_PARENT_REGISTRATION,
      fetchPolicy: 'cache-first',
    });

    const registrationCareType = data?.parentRegistration?.careType;
    if (registrationCareType && LEGACY_SEARCH_CARE_TYPES.includes(registrationCareType)) {
      const url = buildLegacyProviderSearchUrl(
        registrationCareType.toLowerCase(),
        to.query?.zipcode ? String(to.query.zipcode) : undefined
      );
      window.location.href = url;
      next(false);
      return;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking parent registration for search:', error);
  }

  next();
};

export default searchCareTypeGuard;
